export default __webpack_public_path__ + "static/media/torrey_pines_state_park.c61f6eac.jpeg";